<template>
  <div id="app">
    <component :is="layout"></component>
    <p id="countdownBtn" style="display: none;"></p>
    <div class="loading-tourists-mask" v-if="touristsLoading">
      <loading :box-size="14" :round-size="3" :color="'#306fff'"></loading>
    </div>
  </div>
</template>
<script>
import Common from '@/layouts/Common/index'
import { routesArr } from '@/router'
import judge from '@/router/judge'
import { mapState } from 'vuex'
import Noop from '@/layouts/Noop'
import { get, post } from '@/utils/ajax'
import Loading from '@/components/Loading'
import FingerprintJS from '@fingerprintjs/fingerprintjs'
import qs from 'qs'
import { get_cookie_name, clear_cookie } from '@/utils'

export default {
  components: {
    Loading
  },
  computed: {
    ...mapState(['user']),
    layout() {
      switch (this.$route.meta.layout) {
        case 'Noop':
          return Noop
        default:
          return Common
      }
    }
  },
  data() {
    return {
      touristsLoading: true,
      routerList: [], // 保存不需要站点关系的数组
      site_msg: {}
    }
  },
  async mounted() {
    await this.init()
    await this.setBrowserFinger()
  },
  methods: {
    // 获取站点信息设置是否是游客模式，然后进行路由的跳转
    async getSiteMsg() {
      const res = await this.$store.dispatch('getInitSiteMsg')
      this.site_msg = res
      const _touristsLogin = !res.loginEnabled
      if (_touristsLogin) {
        this.touristsLoading = false
        return false
      } else {
        this.touristsLoading = false
        return true
      }
    },
    // 判断是否走站点逻辑（现在router还是空）
    async init() {
      const pathName = window.location.pathname.split('/')[1]
      const specialRouter = ['judge'] // 不走站点关系的域名集合
      if (pathName && specialRouter.indexOf(pathName) > -1) {
        this.touristsLoading = false // 蒙层消失
        this.routerList['judge'] = judge // 数组关系，方便后续拓展
        const index = specialRouter.indexOf(pathName)
        const newRoutesArr = specialRouter[index]
        this.$router.addRoutes(this.routerList[newRoutesArr])
      } else {
        // 先进行信息判断
        this.getSiteMsg().then(async (isNormal) => {
          if (isNormal) {
            // 对接信息素养大赛，免登录，只可能为普通测评
            // 用于签名的key
            const kpcbKeys = ['timestamp', 'userId', 'realName', 'examCode']
            // 是否为信息素养大赛的链接，用于签名的参数都需要校验
            const query = window.location.search.split('?')[1]
            const isKpcb = query && kpcbKeys.every(k => query.indexOf(k) > -1)
            if (isKpcb) {
              try {
                const parsedQuery = qs.parse(decodeURIComponent(query))
                // 获取协议列表
                const list = await get(`${window.CONFIG.api_backend}/tiger/v3/web/accounts/agreements`, { 'auth_version': '1.0.0', credential: true })
                // 无感颁发登录态
                const params = {
                  agreementIds: list.map(item => item.id) || [],
                  pid: 'At8CiphS',
                  ...parsedQuery
                }
                const res = await post(`${window.CONFIG.api_backend}/tiger/v3/web/accounts/oauth/information-literacy`, params, { clientId: 'Web', 'auth_version': '1.0.0', credential: true })
                if (res.auth && res.auth.token) {
                  // 清空前端所写的鉴权相关cookie
                  clear_cookie(get_cookie_name('access'), '')
                  clear_cookie(get_cookie_name('token_type'), '')
                  clear_cookie(get_cookie_name('refresh'), '')
                  clear_cookie(get_cookie_name('refresh'), '.codemao.cn')
                  clear_cookie(get_cookie_name('access'), '.codemao.cn')
                  // 前面的请求仅起到设置cookie（authorization）的作用，后面还是复用iris的逻辑 this.$auth('get_access_token') 会在请求中自己调用
                  this.$store.commit('HAS_TOKEN', true)
                  const result = await post(`/home/edu/examinees/saveCieExaminees`, { ...parsedQuery })
                  if (result.address) {
                    // 跳转列表页
                    window.location.href = `${result.address}/list`
                  } else {
                    window.location.replace('error')
                    throw new Error('保存考生信息失败')
                  }
                }
              } catch (error) {
                window.location.replace('error')
                console.log(error)
              }
            } else {
              try {
                await this.$auth('get_access_token')
                this.$store.commit('HAS_TOKEN', true)
              } catch (error) {
                console.log(error)
              }
            }
          }
          const path = sessionStorage.getItem('path')
          if (path !== pathName) { // 切换站点，移除本地缓存
            sessionStorage.setItem('path', pathName)
            if (path) {
              localStorage.removeItem('examId')
              localStorage.removeItem('examineeId')
              localStorage.removeItem('needIdentity')
              localStorage.removeItem('needNotice')
            }
          }
          await this.getRouter()
        })
      }
    },
    async getRouter() {
      // 加工
      // 过滤掉已有的路由
      const newRoutesArr = [...routesArr]
      const defaultRouter = ['login', 'test', 'list', 'thirdLogin', 'pretest', 'showPaper', 'jumpPage']
      const pathName = window.location.pathname.split('/')[1]
      const path = defaultRouter.indexOf(pathName) > -1 ? '' : '/' + window.location.pathname.split('/')[1]
      if (!pathName || defaultRouter.indexOf(pathName) > -1) {
        this.$message('未找到站点资源')
        return false
      } else {
        await this.getSiteTheme(path, newRoutesArr)
      }
    },
    async getSiteTheme(path, newRoutesArr) {
      let id = 0
      if (this.$store.state.hasToken) {
        const userInfo = await this.$auth('get_profile')
        id = userInfo.id
        this.$store.commit('SET_USER', userInfo)
        localStorage.setItem('user_id', id)
      }
      try {
        const res = await this.$store.dispatch('getInitSiteMsg', id)
        // const realUrl = location.origin + '/' + location.href.split('/')[3]
        // const fakeUrl = 'https://test-test.codemao.cn/ceping777'
        // const prodUrl = location.origin.includes('localhost') ? fakeUrl : realUrl
        // const res = await post('/home/sites/user/info', { url: prodUrl, userId: id || 0 }, { ignoreToken: true })
        newRoutesArr.forEach(item => {
          if (item.redirect) item.redirect = `${path}${item.redirect}`
          item.path = `${path}${item.path}`
        })
        // 新加：是否隐藏个人信息/是否排过考/是否按照指定考试id带参
        const themeInfo = {
          ...res,
          themeColor: res.text_theme + ';',
          lightThemeColor: this.hexToRgba(res.text_theme, 0.15) + ';',
          themeSubColor: this.hexToRgba(res.text_theme, 0.05) + ';',
          buttonShadow: ` 0 6px 12px 0px ${this.hexToRgba(res.btn_theme.split(', ')[1], 0.3)};`,
          buttonBackground: `linear-gradient(135deg,${this.hexToRgba(res.btn_theme.split(', ')[0], 1)} 0%, ${this.hexToRgba(res.btn_theme.split(', ')[1], 1)} 100%);`
        }
        this.$store.commit('SETSTATE', { key: 'theme', value: themeInfo })
        document.title = themeInfo.title
        // 自动排考
        await this.goAutomatic(res)
        this.$router.addRoutes(newRoutesArr)
      } catch (error) {
        console.log(error)
      }
    },
    async goAutomatic(res) {
      // 有选择排考且还没排考
      if (!this.$store.state.hasToken) return
      // 获取是否排过考
      // if (this.$route.query.pageId && !res.arrange && res.has_param) {
      //   const params = await post(`/home/sites/params/auto/arrange`, { address: location.origin + '/' + location.href.split('/')[3], exam_id: this.$route.query.pageId, user_id: this.user.id })
      //   console.log(params)
      // }
      if (res.is_automatic && !res.arrange) {
        // 判断是否是本地环境
        const _origin = location.origin.includes('localhost') ? 'https://test-test.codemao.cn' : location.origin
        const automatic = await post('/home/sites/auto/arrange', { address: _origin + '/' + location.href.split('/')[3], name: this.user.fullname || localStorage.currentAccount || this.user.nickname, userId: this.user.id })
        console.log(automatic)
      }
    },
    hexToRgba(hex, opacity) {
      return 'rgba(' + parseInt('0x' + hex.slice(1, 3)) + ',' + parseInt('0x' + hex.slice(3, 5)) + ',' + parseInt('0x' + hex.slice(5, 7)) + ',' + opacity + ')'
    },
    // 生成浏览器指纹
    async setBrowserFinger() {
      // We recommend to call `load` at application startup.
      const fp = await FingerprintJS.load({
        monitoring: false
      })

      // The FingerprintJS agent is ready.
      // Get a visitor identifier when you'd like to.
      const result = await fp.get()

      // This is the visitor identifier:
      const visitorId = result.visitorId
      this.$store.commit('SETSTATE', { key: 'browserFinger', value: visitorId })
    }
  }
}
</script>

<style lang="scss" src="@/assets/styles/index.scss"></style>
<style lang="scss">
.loading-tourists-mask {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 10;
  background-color: #fafafa;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
